class StockSerializer {
  static deSerialize(data) {
    let deSerializedLevel = null;
    switch (data) {
      case 1:
        deSerializedLevel = 'available';
        break;
      case 2:
        deSerializedLevel = 'low';
        break;
      case 3:
        deSerializedLevel = 'none';
        break;
      case 4:
        deSerializedLevel = 'almostNone';
        break;
      default:
        deSerializedLevel = null;
        break;
    }
    return deSerializedLevel;
  }
}

export { StockSerializer };



// WEBPACK FOOTER //
// ./src/networking/serializers/StockSerializer.js